import { Props_SnippetHoverCards } from "./HoverCards.props";
import { Legacy_CompileMarkdown } from "../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler"

const SnippetHoverCards = (props: Props_SnippetHoverCards) => {
    const { heading, snippet, repeatable_hoverCardsOptions } = props;
    return (
        <section
            className={`snippet-hover-cards snippet-hover-cards--bg-${snippet.background_color?.value}`}
            style={{ backgroundImage: snippet.background_image?.value ? `url(${snippet.background_image.value})` : 'none' }}
        >
            <div className="snippet-hover-cards__container">
                <h2 className={`snippet-hover-cards__heading ${heading.visibility?.value ? '' : 'snippet-hover-cards__heading--hidden'}`}>{ heading.content?.value }</h2>
                <div className="snippet-hover-cards__cards-list">
                    {repeatable_hoverCardsOptions && repeatable_hoverCardsOptions.map((item, index) => (
                        <div key={index} className="snippet-hover-cards__card">
                            <div className="snippet-hover-cards__card-content">
                                <div className="snippet-hover-cards__card--front">
                                    {item.image && (
                                        <img
                                            src={item.image.value}
                                            alt={item.imageAltText?.value}
                                            className="snippet-hover-cards__card-image"
                                        />
                                    )}
                                    {item.title.value && (
                                        <h3 className="snippet-hover-cards__card-title">{item.title.value}</h3>
                                    )}
                                </div>
                                <div className={`snippet-hover-cards__card--back snippet-hover-cards__card--back--${snippet.background_color?.value}`}>
                                    {item.descriptions.value && (
                                        <div className="snippet-hover-cards__card-description">{Legacy_CompileMarkdown(item.descriptions.value)}</div>
                                    )}
                                    {item.linkUrl?.value && item.linkText?.value && (
                                        <a href={item.linkUrl.value} className="snippet-hover-cards__card-link">{item.linkText.value}</a>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default SnippetHoverCards;